import { render } from "./EmployeeSupportAdd.vue?vue&type=template&id=21870090&scoped=true"
import script from "./EmployeeSupportAdd.vue?vue&type=script&lang=js"
export * from "./EmployeeSupportAdd.vue?vue&type=script&lang=js"

import "./EmployeeSupportAdd.vue?vue&type=style&index=0&id=21870090&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21870090"]])

export default __exports__